/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RuntimeTransactionSigner
 */
export interface RuntimeTransactionSigner {
    /**
     * The Oasis address of the transaction signer.
     * @type {string}
     * @memberof RuntimeTransactionSigner
     */
    address: string;
    /**
     * The Ethereum address of this transaction signer.
     * @type {string}
     * @memberof RuntimeTransactionSigner
     */
    address_eth?: string;
    /**
     * The transaction signer nonce.
     * @type {number}
     * @memberof RuntimeTransactionSigner
     */
    nonce: number;
}

export function RuntimeTransactionSignerFromJSON(json: any): RuntimeTransactionSigner {
    return RuntimeTransactionSignerFromJSONTyped(json, false);
}

export function RuntimeTransactionSignerFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuntimeTransactionSigner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': json['address'],
        'address_eth': !exists(json, 'address_eth') ? undefined : json['address_eth'],
        'nonce': json['nonce'],
    };
}

export function RuntimeTransactionSignerToJSON(value?: RuntimeTransactionSigner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
        'address_eth': value.address_eth,
        'nonce': value.nonce,
    };
}


